import { useEffect } from 'react';

import EventGrid from '../../features/events-grid';
import { PrivatePage } from '../../components/private-page';
import { ctGameDefault, ctGameTitle } from '../../constants/text';

export default function MyEvents() {
  useEffect(() => {
    document.title = ctGameTitle + ' - My events';
    return () => {
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'My events', href: 'myevents' }
      ]}
      pageTitle={'Events'}>
      <EventGrid />
    </PrivatePage>
  );
}
